module.exports = __webpack_public_path__ + "static/vodafone_white-9ff98fe723a90abe81e1a315e484fce7.png";